/** Shown when PIN email could not be sent (login after Continue, registration, or Resend). */
export const EMAIL_SUBSYSTEM_USER_MESSAGE =
  "There was a delay in sending your PIN code. Your code will be sent as soon as possible.";

/** Shown when a rejected/suspended user attempts to sign in at the email step. */
export const SUSPENDED_ACCOUNT_MESSAGE =
  'Your account is suspended. Please contact support.';

export function isEmailSubsystemNotice(message) {
  return typeof message === 'string' && message.includes('delay in sending your PIN code');
}

export function isRejectedEngagementStatus(status) {
  return typeof status === 'string' && status.toLowerCase() === 'rejected';
}
